export const actionType = {
    select: "SELECT_CORRECTION",
};

export const elemento_raiz = "config_feriado";
